import { FC } from 'react';
import { Image } from '@chakra-ui/react';

import safeImg from 'assets/brand/safe@2x.png';

type IllustrationProps = {
  image?: string;
};

const Illustration: FC<IllustrationProps> = ({ image }) => (
  <Image
    alt=""
    boxSize="90px"
    marginBottom="space-16"
    role="presentation"
    src={image ?? safeImg}
  />
);

export default Illustration;
